import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipDirective } from '@sb/tooltip';
import { AvatarComponent } from '@sb/ui/avatar';
import { BadgeComponent } from '@sb/ui/badge';
import { IconButtonComponent } from '@sb/ui/button';
import { CheckboxComponent } from '@sb/ui/checkbox';
import { CheckboxTreeComponent } from '@sb/ui/checkbox-tree';
import { DropdownModule } from '@sb/ui/dropdown';
import { IconComponent } from '@sb/ui/icon';
import { InputSelectDirective } from '@sb/ui/input';
import { PaginationComponent } from '@sb/ui/pagination';
import { SearchInputComponent } from '@sb/ui/search-input';
import { SelectComponent } from '@sb/ui/select';
import { TruncatedDirective } from '@sb/ui/truncation';

import { KnowledgeBaseArticleLinkModule } from '../../../pipes/knowledge-base-article-link.module';
import { SharedModule } from '../../../shared/shared.module';
import { SidePanelHeaderComponent } from '../../shared/app-side-panel/side-panel-header.component';
import { EmployeeListActionComponent } from './cells/employee-list-action/employee-list-action.component';
import { EmployeeFilesComponent } from './employee-files/employee-files.component';
import { EmployeeNotesComponent } from './employee-notes/employee-notes.component';
import { EmployeePermissionsTeamsComponent } from './employee-permissions-teams/employee-permissions-teams.component';
import { EmployeeSidebarComponent } from './employee-sidebar/employee-sidebar.component';

const imports = [
  SharedModule,
  RouterModule,
  BadgeComponent,
  DropdownModule,
  IconComponent,
  IconButtonComponent,
  SearchInputComponent,
  SelectComponent,
  PaginationComponent,
  CheckboxComponent,
  InputSelectDirective,
  AvatarComponent,
  TooltipDirective,
  TruncatedDirective,
  CheckboxTreeComponent,
  SidePanelHeaderComponent,
];

const standalone = [
  EmployeeListActionComponent,
  EmployeeFilesComponent,
  EmployeeNotesComponent,
  EmployeePermissionsTeamsComponent,
];

const declarations = [EmployeeSidebarComponent];

@NgModule({
  imports: [...imports, ...standalone, KnowledgeBaseArticleLinkModule],
  declarations: declarations,
  exports: [...imports, ...standalone, ...declarations],
})
export class SharedEmployeeModule {
  static forRoot(): ModuleWithProviders<SharedEmployeeModule> {
    return {
      ngModule: SharedEmployeeModule,
    };
  }
}
